<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="tw-w-[300px]">
      <!-- password & confirm password -->
      <div class="tw-w-full">
        <app-set-password
          class="tw-mt-2"
          passwordLabel="common.newPassword"
          confirmPasswordLabel="common.newRePassword"
          (password)="model.password = $event"
          (form)="passwordForm = $event"
        >
        </app-set-password>
      </div>

      <!-- form btns-->
      <app-form-btns
        class="tw-w-full tw-px-0"
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        closeBgColor="light-dark"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </div>
  </form>
</div>
